import BulkServeContainer from 'PointOfSale/modules/cepCard/container/BulkServeContainer';
import CEPContainer from 'PointOfSale/modules/cepCard/container/CEPContainer';

export { CEPContainer, BulkServeContainer };



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/container/index.js